module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_f_normal.943c076b.png";